import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  accessLevels: require('./AccessLevelsRedux').reducer,
  auditLogs: require('./AuditLogsRedux').reducer,
  ajax: require('./AjaxRedux').reducer,
  auth: require('./AuthRedux').reducer,
  customers: require('./CustomersRedux').reducer,
  controllers: require('./ControllersRedux').reducer,
  distributors: require('./DistributorsRedux').reducer,
  doorControls: require('./DoorControlsRedux').reducer,
  eventReports: require('./EventReportsRedux').reducer,
  openDoor: require('./OpenDoorRedux').reducer,
  personCount: require('./PersonCountRedux').reducer,
  persons: require('./PersonsRedux').reducer,
  schedules: require('./SchedulesRedux').reducer,
  sites: require('./SitesRedux').reducer,
  users: require('./UsersRedux').reducer,
  tags: require('./TagsRedux').reducer,
  tagTypes: require('./TagTypesRedux').reducer,
  webSocket: require('./WebSocketRedux').reducer,
});

export default rootReducer;
